import { useRef, useLayoutEffect } from "react";

export function useRequestAnimation(callback: (timeElapsed: number) => void, isActive: boolean) {
  const savedCallback = useRef(callback);
  savedCallback.current = callback;
  useLayoutEffect(() => {
    let time = 0;
    let frameId = 0;

    function animate() {
      const now = performance.now();
      const deltaTime = (now - time) / 1000; // time from previous frame, in seconds
      time = now;
      savedCallback.current && savedCallback.current(deltaTime);
      frameId = requestAnimationFrame(animate);
    }

    if (isActive) {
      time = performance.now();
      frameId = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(frameId);
    }
  }, [isActive]);
}
